"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HamburgerMenu = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var hamburger_menu_1 = require("../styled/hamburger-menu");

var HamburgerMenu = function HamburgerMenu(_a) {
  var children = _a.children,
      _b = _a.menuTitle,
      menuTitle = _b === void 0 ? 'Open navigation menu' : _b;
  var menuId = (0, use_id_1.useId)();

  var _c = tslib_1.__read((0, react_1.useState)(false), 2),
      isShowing = _c[0],
      setIsShowing = _c[1];

  var isInverse = (0, react_1.useContext)(context_1.TopBarContext).isInverse;
  return react_1.default.createElement(hamburger_menu_1.HamburgerMenu, {
    isShowing: isShowing,
    onClose: function onClose() {
      return setIsShowing(false);
    },
    isDismissible: true,
    isInverse: isInverse
  }, react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "menu",
    size: "small",
    title: menuTitle,
    onClick: function onClick() {
      return setIsShowing(true);
    },
    id: menuId,
    pattern: isInverse ? 'inverse' : 'secondary'
  }), react_1.default.createElement("nav", null, children));
};

exports.HamburgerMenu = HamburgerMenu;